let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Kt5b")).then(() => parcelRequire('iiRWr'));